import "antd/dist/antd.min.css";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom"; // Change here
import { TableProvider } from "./contexts/TableContext";
import Homepage from "./pages/Homepage";
import ItemPage from "./pages/ItemPage";
import SetTable from "./pages/SetTable";
import SetTax from "./pages/SetTax";
import SetService from "./pages/SetService";
import SetMember from "./pages/SetMember";
import AllQrCode from "./pages/AllQrCode";
import SetCategory from "./pages/SetCategory";
import SetMenu from "./pages/SetMenu";
import TableSetting from "./pages/TableSetting";
import Bills from "./pages/Bills";
import Staff from "./pages/Staff";
import Report from "./pages/Report";
import StaffTransactionRecordPage from "./pages/StaffTransactionRecordPage";
import Invoice from "./pages/Invoice";
import General from "./pages/General";
import ClockInOut from "./pages/ClockInOut";
import ProductIcon from "./pages/productIcon";
import Login from "./pages/Login";
import PrivateRoute from "./routes/privateRoute";
import { ValidationProvider } from "./contexts/ValidationContext";
import AppRouter from "./utils/appRouter";
import Inventory from "./pages/inventory";
import Kitchen from "./pages/Kitchen";
import ReceiptDisplay from "./pages/ReceiptDisplay";
import Orders from "./pages/Orders";
import InventoryLog from "./pages/inventorylog";
import EInvoice from "./pages/EInvoice";
import TransactionRecord from "./pages/TransactionRecord";
import Preferences from "./pages/Preferences";


// Wrapper component for routes that need TableContext
const TableContextWrapper = ({ children }) => (
  <TableProvider>{children}</TableProvider>
);

// Wrapper component that combines PrivateRoute and TableContext
const PrivateTableRoute = ({ children, role }) => (
  <PrivateRoute role={role}>
    <TableContextWrapper>{children}</TableContextWrapper>
  </PrivateRoute>
);

function App() {
  return (
    <ValidationProvider>
      <AppRouter>
        {" "}
        {/* Change here */}
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Routes that need TableContext */}
          <Route
            path="/"
            element={
              <PrivateTableRoute>
                <Homepage />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/items"
            element={
              <PrivateTableRoute>
                <ItemPage />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/category"
            element={
              <PrivateTableRoute>
                <SetCategory />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/setTable"
            element={
              <PrivateTableRoute>
                <SetTable />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/tables"
            element={
              <PrivateTableRoute>
                <TableSetting />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/setTax"
            element={
              <PrivateTableRoute>
                <SetTax />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/setService"
            element={
              <PrivateTableRoute>
                <SetService />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/setMember"
            element={
              <PrivateTableRoute>
                <SetMember />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/allQrCode"
            element={
              <PrivateTableRoute>
                <AllQrCode />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/menu"
            element={
              <PrivateTableRoute>
                <SetMenu />
              </PrivateTableRoute>
            }
          />

          
           <Route
            path="/secondDisplay"
            element={
              <PrivateTableRoute>
                <ReceiptDisplay />
              </PrivateTableRoute>
            }
          />
          
          <Route
            path="/cashiers"
            element={
              <PrivateTableRoute>
                <Bills />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/orders"
            element={
              <PrivateTableRoute>
                <Orders />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/staffTransactionsRecord"
            element={
              <PrivateTableRoute>
                <StaffTransactionRecordPage />
              </PrivateTableRoute>
            }
          />

          {/* Admin routes */}
          <Route
            path="/staff"
            element={
              <PrivateTableRoute role="admin">
                <Staff />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/report"
            element={
              <PrivateTableRoute>
                <Report />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/inventory"
            element={
              <PrivateTableRoute>
                <Inventory />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/inventoryLog"
            element={
              <PrivateTableRoute>
                <InventoryLog />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/kitchen"
            element={
              <PrivateTableRoute>
                <Kitchen />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/invoice"
            element={
              <PrivateTableRoute role="admin">
                <Invoice />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/general"
            element={
              <PrivateTableRoute role="admin">
                <General />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/preferences"
            element={
              <PrivateTableRoute role="admin">
                <Preferences />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/clockInOut"
            element={
              <PrivateTableRoute role="admin">
                <ClockInOut />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/productIcon"
            element={
              <PrivateTableRoute role="admin">
                <ProductIcon />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/einvoice"
            element={
              <PrivateTableRoute role="admin">
                <EInvoice />
              </PrivateTableRoute>
            }
          />

          <Route
            path="/transactionRecord"
            element={
              <PrivateTableRoute role="admin">
                <TransactionRecord />
              </PrivateTableRoute>
            }
          />
        </Routes>

        
      </AppRouter>{" "}
      {/* Change here */}
    </ValidationProvider>
  );
}

export default App;
